<button 
  [disabled]="isUploading"
  (click)="onUploaderClick()"
  class="button-primary button-primary--upload">
  <input 
    type="file"
    #defaultFileUploader
    (change)="onFileSelect($event.target.files)"
    class="hidden">

  <fa-icon [icon]="['far', 'file-upload']"></fa-icon>
    Upload style
</button>

<button 
  disabled
  class="button-primary button-primary--white"
  *ngIf="isUploading">
  <fa-icon [icon]="['far', 'file-upload']"></fa-icon>
  <progress-bar
    [progress]="percentageDone">
  </progress-bar>
</button>

<ng-template #invalidMessage>
  <div class="text--sm text--error">
    Please upload a file with the maximum size of {{ maxSizeInKilobytes / 1000 }} MB and in the one of the following file formats: {{ invalidFileFormatText }}.
  </div>  
</ng-template>

